import { render } from "./SideMenuList.vue?vue&type=template&id=17028d6b"
import script from "./SideMenuList.vue?vue&type=script&lang=js"
export * from "./SideMenuList.vue?vue&type=script&lang=js"

import "./SideMenuList.vue?vue&type=style&index=0&id=17028d6b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__